export default __webpack_public_path__ + "static/media/learn_speed.593a0700.svg";